import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Progress } from '@backstage/core-components';
import { useRbac } from './hooks';
import {
  RbacPermission,
  RbacRole,
} from '../../plugins/infrastructure/rbacTypes';

/**
 * Renders children only if the current user holds `permission`; otherwise
 * redirects home. While the role is still loading a spinner is shown so we
 * never flash a redirect before the role is known. This is UI convenience
 * only — the backend independently enforces the same permission.
 */
export function RequirePermission({
  permission,
  children,
}: {
  permission: RbacPermission;
  children: ReactNode;
}) {
  const { permissions, loading } = useRbac();
  if (loading) return <Progress />;
  if (!permissions.includes(permission)) return <Navigate to="/" replace />;
  return <>{children}</>;
}

export function RequireRole({
  role,
  children,
}: {
  role: RbacRole;
  children: ReactNode;
}) {
  const { role: current, loading } = useRbac();
  if (loading) return <Progress />;
  if (current !== role) return <Navigate to="/" replace />;
  return <>{children}</>;
}
